import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from './firebase';

export class AutoLinkingService {
  static async createUserLinkingCode(
    userId: string,
    role: string
  ): Promise<string> {
    try {
      const prefix = role === 'student' ? 'S' : role === 'parent' ? 'P' : 'T';
      const randomCode = Math.random()
        .toString(36)
        .substring(2, 10)
        .toUpperCase();
      const code = `${prefix}-${randomCode}`;

      await setDoc(doc(db, 'linkingCodes', code), {
        code,
        userId,
        userType: role,
        isActive: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        codeType: 'permanent',
        usageCount: 0,
        maxUsage: -1,
        createdBy: 'system',
        metadata: {
          autoGenerated: true,
          registrationDate: new Date().toISOString(),
        },
      });

      return code;
    } catch (error) {
      console.error('Error creating linking code:', error);
      return `AUTO-${Math.random().toString(36).substring(2, 8).toUpperCase()}`;
    }
  }

  static async linkStudentToDefaultTeacher(studentId: string): Promise<void> {
    void studentId;
    console.warn(
      'Legacy auto-link to default teacher is disabled. Create a tenant link request instead.'
    );
  }

  static async autoLinkStudentToParent(
    studentId: string,
    parentCode?: string,
    studentEmail?: string,
    studentPhone?: string
  ): Promise<boolean> {
    void studentId;
    void parentCode;
    void studentEmail;
    void studentPhone;
    console.warn(
      'Legacy student-parent auto-link is disabled. Use tenantService.createLinkRequest after registration.'
    );
    return false;
  }

  static async autoLinkParentToStudent(
    parentId: string,
    studentCode: string
  ): Promise<boolean> {
    void parentId;
    void studentCode;
    console.warn(
      'Legacy parent-student auto-link is disabled. Use tenantService.createLinkRequest after registration.'
    );
    return false;
  }

  static async createRelationRecord(
    studentId: string,
    parentId: string,
    teacherId?: string
  ): Promise<void> {
    void studentId;
    void parentId;
    void teacherId;
    console.warn(
      'Legacy relation record creation is disabled. Approved links are written by Cloud Functions under teachers/{teacherId}.'
    );
  }

  static async canModifyStudentLink(
    userId: string,
    studentId: string
  ): Promise<boolean> {
    try {
      const userDocument = await getDoc(doc(db, 'users', userId));
      if (!userDocument.exists()) return false;

      const userData = userDocument.data();
      if (userData.role === 'admin') return true;
      if (userData.role !== 'teacher') return false;

      const membershipDocument = await getDoc(
        doc(db, 'users', studentId, 'memberships', userId)
      );
      return (
        membershipDocument.exists() &&
        membershipDocument.data()?.role === 'student' &&
        membershipDocument.data()?.status === 'active'
      );
    } catch (error) {
      console.error('Error checking modify permissions:', error);
      return false;
    }
  }
}

export default AutoLinkingService;
